import React, { useContext, useEffect, useRef, useState } from "react";
import classes from './LocationMaster.module.css';
import axios from "../../../../Axios/Axios";
import { Urls } from "../../../../Urls";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import mixpanel from 'mixpanel-browser';
import { DeleteMastersApi, MastersChangeLog, getCompanyMasterPagination, getProfileDetails, saveMastersApi } from "../../Utility";
import { toast } from "react-toastify";
import ShowHistory from "../../../Planning/components/ShowHistory";
import PopupModal from "../../../Shared/PopupModal/PopupModal";
import Pagination from "react-js-pagination";
import 'react-datepicker/dist/react-datepicker.css';
import LocationMasterTable from "./LocationMasterTable";
import LocationUploadExcel from "./LocationUploadExcel";
import DownloadMastersButton from "../Utility/DownloadMastersButton";
import LocationInputForm from "./LocationInputs";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import { isSuperUser } from "../FreightMaster/UploadExcel/Step1/utils";
import { EditableEmailsContext } from "../../../../Context/EditableEmailsContext";
import { sendMailToMasters } from "../Utility/utility";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel"; // <--- ADJUST THIS PATH
import MultiSelectFilterUI from "../../../Shared/newfilterui/MultiSelectFilterUI";


/**
 * TODO - move function used in only specific component to that component
 */
const LocationMaster = ({ canedit = true, canAccess, canUpdate, checkActionPermission }) => {
    const [locationName, setLocationName] = useState('')
    const [locationAddress, setLocationAddress] = useState('')
    const [locationType, setLocationType] = useState('Destination')
    const [generateCode, setGenerateCode] = useState('')
    const [pinCode, setPinCode] = useState('')
    const [customerName, setCustomerName] = useState('')
    const [gstNo, setGstNo] = useState('')
    const [locationMasterList, setLocationMasterList] = useState([])
    const { userDetails } = useContext(UserApiContext)
    const [company_id, setcompany_id] = useState('')
    const [origin, setorigin] = useState()
    const [show, setshow] = useState(false)
    const { companyProfile } = useContext(UserApiContext)
    const [remark, setRemark] = useState('')
    const [deletion_list, setDeletion_list] = useState([])
    const [skipactive, setSkipactive] = useState(0);
    const [totalcount, settotalcount] = useState(0);
    const [openTime, setOpenTime] = useState(new Date());
    const [closeTime, setCloseTime] = useState(new Date());
    const [truckOptions, setTruckOptions] = useState([])
    const [selectedTruck, setselectedTruck] = useState("");
    const [currentFuelRate, setcurrentFuelRate] = useState()
    const [isOrgLevel, setIsOrgLevel] = useState(false)
    const [haltingTime, setHaltingTime] = useState(1);
    const [errorMessage, setErrorMessage] = useState("");
    const { companySettingData } = useContext(MyCompanyProfileContext)
    const [selectedOrg, setSelectedOrg] = useState("company")
    const [orgList, setOrgList] = useState([])
    const emailData = useContext(EditableEmailsContext);
    const [isFilterLoading, setIsFilterLoading] = useState(false);
    const [isFilterActive, setIsFilterActive] = useState(false);
    const [filterPayload, setFilterPayload] = useState(null);
    const [filtersshown, setfiltershown] = useState(false);

    const DEFAULT_SORT_OPTIONS = [
        { value: 'location', label: 'Location Name' },
        { value: 'location_type', label: 'Location Type' },
        { value: 'location_code', label: 'Location Code' },
        { value: 'pincode', label: 'Pin Code' },
        { value: 'customer_name', label: 'Customer Name' },
    ];

    const lastFetchedCompanyId = useRef(null);
    const isOrgMounted = useRef(false);

    const [superAdmins, setSuperAdmin] = useState([])
    const [emailTemplate, setEmailTemplate] = useState({
        from: '',
        content: '',
        subject: '',
        cc: [],
        description: ''
    })

    const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
    useEffect(() => {
        if (emailData && emailData?.notifyEmailForMastersUpdate) {
            setEmailTemplate({
                content: emailData?.notifyEmailForMastersUpdate?.content,
                subject: emailData?.notifyEmailForMastersUpdate?.subject,
                cc: emailData?.notifyEmailForMastersUpdate?.cc || "connect@logisticsnow.in",
                from: emailData?.notifyEmailForMastersUpdate?.from,
                description: emailData?.notifyEmailForMastersUpdate?.email_description
            })
        }
    }, [emailData])

    useEffect(() => {
        if (companySettingData && companySettingData?.contact_information && companySettingData?.contact_information?.length > 0) {
            const superAdminEmails = companySettingData?.contact_information?.filter((t) => t?.super_admin === true)?.map((m) => {
                return {
                    name: m?.name,
                    email: m?.email
                }
            })
            if (superAdminEmails && superAdminEmails?.length > 0) {
                setSuperAdmin(superAdminEmails)
            } else {
                setSuperAdmin([])
            }
        } else {
            setSuperAdmin([])
        }
    }, [companySettingData])
    /**
     * Builds the default fetch payload for Location Master
     */
    const buildDefaultPayload = (skip = 0, limit = 500) => ({
        filter_opertaion: 'and',
        date_range: [],
        filters: [],
        search: '',
        sort: { key: 'location', order: 'asc' },
        pagination: { skip, limit },
    });

    /**
     * Fetches location master data using the filter-payload API
     * @param {Object} payload - filter/sort/pagination payload
     * @param {string} orgId   - organisation id (optional)
     */
    const getLocationData = (payload, orgId, showToast = false) => {
        setshow(true);
        const org = orgId || selectedOrg;
        const orgParam = org && org !== 'company' ? `&organization_id=${org}` : '';
        const url = `${Urls.companyMaster}?master_type=location&action=fetch_masters_data${orgParam}`;
        axios
            .post(url, payload)
            .then(res => {
                let count = 0;
                if (res.data && res.data.master_details) {
                    setLocationMasterList(res.data.master_details);
                    settotalcount(res.data.total);
                    count = res.data.total;
                } else if (res.data && Array.isArray(res.data)) {
                    setLocationMasterList(res.data);
                    settotalcount(res.data.length);
                    count = res.data.length;
                }
                if (showToast) {
                    toast.success(`Found ${count} results`);
                }
                setshow(false);
            })
            .catch(err => {
                console.log(err);
                if (showToast) {
                    toast.error("Failed to apply filters");
                }
                setshow(false);
            });
    };

    useEffect(() => {
        const id = companyProfile?.domain_data?.company_id;
        if (!id || !userDetails) return;               // context not ready yet
        if (id === lastFetchedCompanyId.current) return; // already fetched for this company

        lastFetchedCompanyId.current = id;
        setcompany_id(id);

        // Fetch location master data (ascending by location name)
        getLocationData(buildDefaultPayload(0, 500), selectedOrg);

        // Fetch truck options for dropdowns
        getProfileDetails(id, 'truck_details', 'company')
            .then(res => {
                if (res.data && res.data[0]?.truck_details) {
                    setTruckOptions(
                        res.data[0].truck_details.map(o => ({ label: o.truck_type, value: o.truck_type }))
                    );
                }
            })
            .catch(err => console.log(err));
    }, [companyProfile, userDetails]); // ← selectedOrg intentionally excluded from initial load

    useEffect(() => {
        if (!isOrgMounted.current) {
            isOrgMounted.current = true;
            return; // skip initial mount
        }
        if (!lastFetchedCompanyId.current) return; // company not loaded yet
        getLocationData(buildDefaultPayload(0, 500), selectedOrg);
    }, [selectedOrg]);

    useEffect(() => {
        if (companySettingData && companySettingData.contact_information) {
            const result = isSuperUser(companySettingData.contact_information);
            if (result) {
                if (result.organizationList && result.organizationList.length > 0) {
                    setOrgList(result.organizationList)
                }
            }
        }
        if (companySettingData && companySettingData.masters_setting) {
            if (companySettingData.masters_setting.masters_show_level && companySettingData.masters_setting.masters_show_level === "organization_level") {
                setIsOrgLevel(true)
            }
        }
    }, [companySettingData])

    const handleHaltingtimeChange = (e) => {
        const value = e.target.value;
        if (value < 0) {
            setErrorMessage("Hours must be greater than 0");
        } else if (value > 2000) {
            setErrorMessage("Hours cannot be greater than 2000")
        } else {
            setHaltingTime(value);
            setErrorMessage("");
        }
    };

    /**
     * Generates a random code of length 
     * @param {number} length - length of the code to generate
     */
    const generateRandomCode = (length) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let code = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            code += characters.charAt(randomIndex);
        }
        setGenerateCode(code.toUpperCase())
    }

    /**
     * Function to format time from Date object
     * @param {Date} dateAndTime - date and time to format
     * @returns {string} formatted time string
     */
    const getTime = (dateAndTime) => {
        const date = new Date(dateAndTime);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        return formattedTime
    }

    /**
     * Adds a new location to the master list
     */
    const add_location_master = () => {

        const sqlInjectionPatterns = /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;
        // Form validation
        if (!origin || origin === 'undefined' || sqlInjectionPatterns.test(origin)) {
            toast.error('Please select location from dropdown')
        } else if (sqlInjectionPatterns.test(locationAddress)) {
            toast.error('Please add valid address')
        }
        else if (sqlInjectionPatterns.test(generateCode)) {
            toast.error('Please add valid location code')
        }
        else if (haltingTime === "" || !haltingTime || isNaN(haltingTime)) {
            toast.error("Please enter valid Halting time!")
        } else if (currentFuelRate < 1 || sqlInjectionPatterns.test(currentFuelRate)) {
            toast.error("Please enter valid fuel rate!")
            return false
        } else {
            setshow(true)
            const selectedTrucks = selectedTruck && selectedTruck.length > 0 ? selectedTruck.map(item => ({ truck_type: item.value })) : [];
            const locationMaster = {
                addressLine1: locationAddress,
                addressLine2: '',
                location: origin,
                type: locationType,
                location_code: generateCode,
                pincode: String(pinCode ?? ""),
                customer_name: customerName,
                gst_no: gstNo,
                location_timings: [{ open: getTime(openTime), close: getTime(closeTime) }],
                truck_availability: selectedTrucks,
                halting_time: (haltingTime * 60),
                current_rate: parseFloat(currentFuelRate),
            }

            // Saving location master data using API
            saveMastersApi(company_id, 'location', [locationMaster], selectedOrg, TrackMixPanel)
                .then((res) => {
                    const apiData = res && res.data ? res.data : res;
                    const apiError = apiData && apiData.error;

                    if (Array.isArray(apiError)) {
                        const duplicateError = apiError.find(
                            (err) =>
                                typeof err?.message === 'string' &&
                                err.message.toLowerCase().includes('location code already exists')
                        );

                        if (duplicateError) {
                            setshow(false);
                            toast.error('Location Code already exists');
                            return;
                        }
                    }

                    setGenerateCode('');
                    setshow(false);
                    toast.success('Details Added Successfully')
                    // Logging activity for change log
                    const activity = {
                        "location_code": locationMaster.location_code,
                        "location_name": locationMaster.location.location_name,
                        "addressLine1": locationMaster.addressLine1
                    }

                    sendMailToMasters("Location Master", emailTemplate,
                        superAdmins,
                        {
                            action: "New Location Added",
                            lane: locationMaster,
                        },
                        setshow,
                        userDetails?.user_name || userDetails?.email?.split("@")[0]
                    )
                    MastersChangeLog("Line Item Added", "location_master", userDetails.email, userDetails.user_id, company_id, activity, "")
                    const mixpanelData = `User added location name:${locationMaster?.location?.location_name ? locationMaster.location.location_name : 'none'}, location code : ${locationMaster?.location_code ? locationMaster.location_code : 'none'}, location address :${locationMaster?.addressLine1 ? locationMaster?.addressLine1 : 'none'}, location type :${locationMaster?.type ? locationMaster.type : 'none'}, location pincode: ${locationMaster?.pincode ? locationMaster.pincode : 'none'}, customer name : ${locationMaster?.customer_name ? locationMaster.customer_name : 'none'}, gst no : ${locationMaster?.gst_no ? locationMaster.gst_no : 'none'}`;

                    TrackMixPanel({
                        ModuleName: 'masters',
                        ScreenName: 'location master',
                        Definition: ` user has clicked on add details location master button `,
                        Data: mixpanelData,
                    });
                    setLocationName('')
                    setLocationAddress('')
                    setGenerateCode('')
                    setPinCode('')
                    setorigin('')
                    setCustomerName('')
                    setGstNo('')
                    setselectedTruck('')
                    setHaltingTime(1)
                })
                .catch((error) => {
                    console.log(error)
                    setshow(false)
                    const apiError =
                        error?.response?.data?.error ||
                        error?.data?.error ||
                        error?.error ||
                        [];

                    if (Array.isArray(apiError)) {
                        const duplicateError = apiError.find(
                            (err) =>
                                typeof err?.message === 'string' &&
                                err.message.toLowerCase().includes('location code already exists')
                        );

                        if (duplicateError) {
                            toast.error('Location Code already exists');
                            return;
                        }
                    }

                    toast.error('Something went wrong while adding location details.');
                });
        }
    }

    /**
     * Handles deletion of a location from the master list
     * @param {Event} e - click event
     * @param {Object} item - location item to delete
     */
    const deleteHandler = (e, item) => {
        // Confirm deletion with user
        if (window.confirm("Are you sure you want to delete this lane?")) {
            setshow(true)
            const temp = locationMasterList  // Create a copy of locationMasterList
            let list = []
            // Filter out the item to be deleted
            if (temp && temp.length > 0) {
                temp.map(data => {
                    if (data !== item) {
                        list.push(data)
                    }
                })
            }

            // Call DeleteMastersApi to delete the item
            DeleteMastersApi(company_id, 'location', [item], selectedOrg, TrackMixPanel)
                .then((res) => {
                    setshow(false)
                    toast.success("Deleted successfully")
                    setLocationMasterList(list)
                    // Log deletion activity
                    const activity = [{
                        "location_code": item.location_code,
                        "location_name": item.location_name,
                        "address": item.addressLine1
                    }]
                    sendMailToMasters("Location Master", emailTemplate,
                        superAdmins,
                        {
                            action: "Location Deleted",
                            lane: item,
                        },
                        setshow,
                        userDetails?.user_name || userDetails?.email?.split("@")[0]
                    )
                    MastersChangeLog("Line Item Deleted", "location_master", userDetails.email, userDetails.user_id, company_id, activity, remark)
                    TrackMixPanel({
                        ModuleName: 'masters',
                        ScreenName: 'location master',
                        Definition: `user has clicked on location master delete button`,
                        Data: `location: ${item?.location?.location_name ? item.location.location_name : 'none'}, location code: ${item?.location_code ? item.location_code : 'none'}, location address: ${item?.addressLine1 ? item.addressLine1 : 'none'}, location type: ${item?.type ? item.type : 'none'},location pincode: ${item?.pincode ? item.pincode : 'none'} , customer name : ${item?.customer_name ? item.customer_name : 'none'}, gst no : ${item?.gst_no ? item.gst_no : 'none'}`
                        ,
                    });
                })
                .catch((error) => {
                    console.log(error)
                    setshow(false)
                })
        }
    }

    /**
    * Handles selection of all items for deletion
    * @param {Event} e - The checkbox change event
    */
    const selectAllHandler = (e) => {
        if (e.target.checked) {
            let list = deletion_list.slice()
            if (locationMasterList && locationMasterList.length > 0) {
                locationMasterList.map(item => {
                    if (!deletion_list.includes(item)) {
                        list.push(item)
                    }
                })
                setDeletion_list(list)
            }
        } else {
            setDeletion_list([])
        }
    }

    /**
    * Handles checkbox selection for individual items
    * @param {Event} e - checkbox change event
    * @param {Object} item - The selected item
    */
    const checkboxeshandler = (e, item) => {
        if (e.target.checked) {
            let list = deletion_list.slice()
            list.push(item)
            setDeletion_list(list)
        } else {
            const temp = deletion_list.filter(value => {
                return value !== item;
            });
            setDeletion_list(temp)
        }
    }

    /**
     * Deletes selected lanes from the master list
     * @param {Event} e - click event
     */
    const deleteLanes = (e) => {
        if (deletion_list && deletion_list.length > 0) {
            if (window.confirm("Are you sure to delete?")) {
                const deletedLanesData = deletion_list.map((deletedLane) => deletedLane.location_code);
                const dataString = deletion_list.length === locationMasterList.length && locationMasterList.length > 3
                    ? 'All Lanes'
                    : `lanes with location code: ${deletedLanesData}`;
                TrackMixPanel({
                    ModuleName: 'masters',
                    ScreenName: 'location_master',
                    Definition: `user has clicked on location master all lane delete button`,
                    Data: `user deleted ${dataString}`,
                });
                // ------------------------------------------------------------------------------------------

                setshow(true)
                const payload = {
                    "data": deletion_list
                }
                let finalUrl = ""
                if (selectedOrg === "company" || !selectedOrg || selectedOrg === undefined) {
                    finalUrl = `${Urls.companyMaster}?company_id=${companyProfile.domain_data.company_id}&master_type=location&status=deleted`
                } else {
                    finalUrl = `${Urls.companyMaster}?company_id=${companyProfile.domain_data.company_id}&organization_id=${selectedOrg}&master_type=location&status=deleted`
                }
                axios.post(finalUrl, payload)
                    .then(res => {
                        sendMailToMasters(
                            "Location Master",
                            emailTemplate,
                            superAdmins,
                            {

                                action: `Multiple Item(s) Deleted`,
                                lane: '',
                            },
                            setshow,
                            userDetails?.user_name || userDetails?.email?.split("@")[0]
                        );
                        const activity =
                            deletion_list.length > 0
                                ? deletion_list.map((item) => ({
                                    location_code: item?.location_code || "",
                                    location_name:
                                        item?.location?.location_name ||
                                        item?.location_name ||
                                        "",
                                    address: item?.addressLine1 || "",
                                }))
                                : null;

                        if (activity && activity.length > 0) {
                            MastersChangeLog(
                                "Line Item Deleted",
                                "location_master",
                                userDetails?.email ?? "",
                                userDetails?.user_id ?? "",
                                company_id ?? "",
                                activity,
                                remark ?? ""
                            );
                        }


                        toast.success("Lanes deleted successfully")
                        const updatedList = locationMasterList.filter(
                            (lane) => !deletion_list.some((deletedLane) => deletedLane === lane)
                        );
                        setLocationMasterList(updatedList)
                        setshow(false)
                        setDeletion_list([])
                    })
                    .catch(err => {
                        console.log(err)
                        setshow(false)
                    })
            }
        } else {
            toast.error('Please Select atleast 1 item');
            return false;
        }
    }

    /**
     * Handle filter application — mirrors FreightMaster.handleFilterApply
     * @param {Object} payload - filter payload from MultiSelectFilterUI
     * @param {boolean} showToast - whether to show a result toast
     */
    const handleFilterApply = (payload, showToast = true) => {
        setIsFilterLoading(true);
        setIsFilterActive(true);
        setFilterPayload(payload);

        if (payload?.pagination?.skip === 0) {
            setSkipactive(0);
        }

        getLocationData(payload, selectedOrg, showToast);
        setIsFilterLoading(false);
    };

    /**
     * Handle filter reset — mirrors FreightMaster.handleFilterReset
     */
    const handleFilterReset = () => {
        setIsFilterActive(false);
        setFilterPayload(null);
        setSkipactive(0);
        getLocationData(buildDefaultPayload(0, 500), selectedOrg);
        toast.info('Filters reset');
    };

    /**
     * Active filter pills — mirrors FreightMaster.ActiveFilterPills
     */
    const ActiveFilterPills = () => {
        if (!isFilterActive || !filterPayload) return null;

        const hasFilters = filterPayload.filters && filterPayload.filters.length > 0;
        const hasSearch = filterPayload.search && filterPayload.search.trim() !== '';

        const currentSortKey = filterPayload.sort?.key;
        const isDefaultSort = currentSortKey === 'location' || !currentSortKey;
        const currentSortLabel = DEFAULT_SORT_OPTIONS.find(o => o.value === currentSortKey)?.label || currentSortKey;
        const hasSort = !isDefaultSort;

        const currentLimit = filterPayload.pagination?.limit;
        const hasPagination = currentLimit && currentLimit !== 500;

        if (!hasFilters && !hasSearch && !hasSort && !hasPagination) return null;

        const removeFilter = (filterKey) => {
            const updatedFilters = filterPayload.filters.filter(f => f.key !== filterKey);
            if (updatedFilters.length === 0 && (!filterPayload.search || filterPayload.search.trim() === '') && !hasSort && !hasPagination) {
                handleFilterReset();
            } else {
                const updated = { ...filterPayload, filters: updatedFilters, pagination: { ...filterPayload.pagination, skip: 0 } };
                setFilterPayload(updated);
                handleFilterApply(updated);
            }
        };

        const clearSearch = () => {
            const updated = { ...filterPayload, search: '', pagination: { ...filterPayload.pagination, skip: 0 } };
            if (!hasFilters && !hasSort && !hasPagination) {
                handleFilterReset();
            } else {
                setFilterPayload(updated);
                handleFilterApply(updated);
            }
        };

        const resetSort = () => {
            const updated = { ...filterPayload, sort: { key: 'location', order: 'asc' }, pagination: { ...filterPayload.pagination, skip: 0 } };
            if (!hasFilters && !hasSearch && !hasPagination) {
                handleFilterReset();
            } else {
                setFilterPayload(updated);
                handleFilterApply(updated);
            }
        };

        const resetPagination = () => {
            const updated = { ...filterPayload, pagination: { ...filterPayload.pagination, limit: 500, skip: 0 } };
            if (!hasFilters && !hasSearch && !hasSort) {
                handleFilterReset();
            } else {
                setFilterPayload(updated);
                handleFilterApply(updated);
            }
        };

        const formatValue = (value) => Array.isArray(value) ? value.join(', ') : value;

        return (
            <div className="active-filters-area" style={{
                backgroundColor: '#f8f9fa',
                border: '1px solid #e9ecef',
                borderBottom: 'none',
                borderRadius: '4px 4px 0 0',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '8px',
                boxSizing: 'border-box',
                padding: '8px 12px',
                maxWidth: '100%',
                overflow: 'hidden',
                marginBottom: 0
            }}>
                <div className="d-flex align-items-center mr-2" style={{ borderRight: '1px solid #dee2e6', paddingRight: '12px' }}>
                    <i className="fa fa-filter mr-2 text-primary" style={{ fontSize: '14px' }} />
                    <span className="text-uppercase font-weight-bold text-muted" style={{ fontSize: '10px', letterSpacing: '1px', whiteSpace: 'nowrap' }}>
                        Active Filters
                    </span>
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', flex: '1', alignItems: 'center', minWidth: 0 }}>
                    {hasSearch && (
                        <div className="filter-pill d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1">
                            <span style={{ fontSize: '12px', color: '#444' }}>
                                <i className="fa fa-search mr-1 text-info" style={{ fontSize: '10px' }} />
                                <strong className="mr-1">Search:</strong> {filterPayload.search}
                            </span>
                            <i className="fa fa-times ml-2 text-danger" onClick={clearSearch} style={{ cursor: 'pointer', fontSize: '12px' }} />
                        </div>
                    )}

                    {filterPayload.filters?.map((f, i) => (
                        <div key={`${f.key}_${i}`} className="filter-pill d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1">
                            <span style={{ fontSize: '12px', color: '#444' }}>
                                <i className="fa fa-check-circle mr-1 text-success" style={{ fontSize: '10px' }} />
                                <strong className="mr-1">{f.label || f.key}:</strong> {formatValue(f.values)}
                            </span>
                            <i className="fa fa-times ml-2 text-danger" onClick={() => removeFilter(f.key)} style={{ cursor: 'pointer', fontSize: '12px' }} />
                        </div>
                    ))}

                    {hasSort && (
                        <div className="filter-pill d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1">
                            <span style={{ fontSize: '12px', color: '#444' }}>
                                <i className="fa fa-sort mr-1 text-warning" style={{ fontSize: '10px' }} />
                                <strong className="mr-1">Sort:</strong> {currentSortLabel}
                            </span>
                            <i className="fa fa-times ml-2 text-danger" onClick={resetSort} style={{ cursor: 'pointer', fontSize: '12px' }} />
                        </div>
                    )}

                    {hasPagination && (
                        <div className="filter-pill d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1">
                            <span style={{ fontSize: '12px', color: '#444' }}>
                                <i className="fa fa-list-ol mr-1" style={{ fontSize: '10px' }} />
                                <strong className="mr-1">Limit:</strong> {currentLimit}
                            </span>
                            <i className="fa fa-times ml-2 text-danger" onClick={resetPagination} style={{ cursor: 'pointer', fontSize: '12px' }} />
                        </div>
                    )}
                </div>

                <button
                    className="btn btn-sm btn-link text-danger"
                    onClick={handleFilterReset}
                    style={{ fontSize: '12px', fontWeight: 'bold', textDecoration: 'none', padding: '4px 8px', whiteSpace: 'nowrap', marginLeft: '8px' }}
                >
                    Clear All
                </button>
            </div>
        );
    };

    /**
    * Handles pagination change
    * @param {number} e - event for new page number
    */
    const getOnChange = (e) => {
        setSkipactive(e);
        if (isFilterActive && filterPayload) {
            const currentLimit = filterPayload?.pagination?.limit || 500;
            const dynamicSkip = (e - 1) * currentLimit;
            const updated = {
                ...filterPayload,
                pagination: { ...filterPayload.pagination, skip: dynamicSkip, limit: currentLimit }
            };
            setFilterPayload(updated);
            getLocationData(updated, selectedOrg);
        } else {
            const calculatedSkip = (e - 1) * 500;
            getLocationData(buildDefaultPayload(calculatedSkip, 500), selectedOrg);
        }
    }

    /**
     * ViewTruckDetails component for displaying available trucks
     * @param {Object} locationMaster - location master data
     * @returns {JSX.Element} rendered ViewTruckDetails component
     */
    const ViewTruckDetails = ({ locationMaster }) => {
        return (
            <div style={{ overflowY: "scroll", overflowX: 'hidden', wordWrap: 'break-word', maxHeight: "50vh" }}>
                {locationMaster && locationMaster.truck_availability && locationMaster.truck_availability.length > 0 ?
                    locationMaster.truck_availability.map((truck, index) => {
                        return (
                            <div className="row px-4">
                                <div>{index + 1}.</div>
                                <div className="ml-2">{truck.truck_type}</div>
                            </div>
                        )
                    })
                    : <div className="text-center">No truck details to show</div>
                }
            </div>
        )
    }

    return (
        <>
            {/* Advanced Filter Drawer — mirrors FreightMaster */}
            {filtersshown && (
                <div className="mt-4 mb-4">
                    <MultiSelectFilterUI
                        module="LocationMaster"
                        action="filterable_fields"
                        filterBaseUrl={Urls.planning_master_filters}
                        uniqueValuesMasterType="location"
                        defaultFields={[
                            { key: 'location', label: 'Location Name', type: 'text' },
                            { key: 'location_type', label: 'Location Type', type: 'enum' },
                            { key: 'location_code', label: 'Location Code', type: 'text' },
                            { key: 'pincode', label: 'Pin Code', type: 'text' },
                            { key: 'customer_name', label: 'Customer Name', type: 'text' },
                        ]}
                        defaultSortOptions={DEFAULT_SORT_OPTIONS}
                        onFilterApply={handleFilterApply}
                        onReset={handleFilterReset}
                        initialPayload={filterPayload}
                        isLoading={isFilterLoading || show}
                        onClose={() => setfiltershown(false)}
                        showSearch={false}
                    />
                </div>
            )}

            <div className="pr-5">
                <div className={`d-flex align-items-center justify-content-between px-2 ${classes.locationMasterHeader}`}>
                    {/* Left Side: Management Action Buttons */}
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <PopupModal
                            buttonLabel={
                                <>
                                    <i className="fa fa-plus pr-2" />
                                    Add Location Master
                                </>
                            }
                            buttonClass="btn btn-primary"
                            dialogClassName={classes["custom-modal-70"]}
                            id="add-location-master-modal"
                            title="Add Location Master"
                            content={({ onClose }) => (
                                <div className="p-3">
                                    <div className="row m-0">
                                    <LocationInputForm
                                        locationName={locationName}
                                        setLocationName={setLocationName}
                                        setorigin={setorigin}
                                        locationAddress={locationAddress}
                                        setLocationAddress={setLocationAddress}
                                        locationType={locationType}
                                        generateCode={generateCode}
                                        setGenerateCode={setGenerateCode}
                                        generateRandomCode={generateRandomCode}
                                        pinCode={pinCode}
                                        setPinCode={setPinCode}
                                        customerName={customerName}
                                        setCustomerName={setCustomerName}
                                        gstNo={gstNo}
                                        setGstNo={setGstNo}
                                        openTime={openTime}
                                        setOpenTime={setOpenTime}
                                        closeTime={closeTime}
                                        setCloseTime={setCloseTime}
                                        truckOptions={truckOptions}
                                        selectedTruck={selectedTruck}
                                        setselectedTruck={setselectedTruck}
                                        haltingTime={haltingTime}
                                        handleHaltingtimeChange={handleHaltingtimeChange}
                                        errorMessage={errorMessage}
                                        setLocationType={setLocationType}
                                        currentFuelRate={currentFuelRate}
                                        setcurrentFuelRate={setcurrentFuelRate}
                                        company_id={company_id}
                                        canedit={canedit}
                                        canAccess={canAccess}
                                        canUpdate={canUpdate}
                                        checkActionPermission={checkActionPermission}
                                    />
                                    </div>
                                    <div className="d-flex justify-content-end mt-4 pr-3">
                                        <button
                                            className="btn btn-success"
                                            disabled={canedit || !canUpdate}
                                            onClick={() => {
                                                add_location_master();
                                                onClose();
                                            }}
                                        >
                                            Add Details
                                        </button>
                                    </div>
                                </div>
                            )}
                            screenName="Location Master"
                            moduleName="Masters"
                            backdrop={true}
                        />

                        <PopupModal
                            buttonLabel={
                                <>
                                    <i className="fa fa-upload pr-2" />
                                    Upload
                                </>
                            }
                            buttonClass="btn btn-primary"
                            disabled={canedit || !canUpdate}
                            content={({ onClose }) => (
                                <LocationUploadExcel
                                    locationMasterList={locationMasterList}
                                    setLocationMasterList={setLocationMasterList}
                                    company_id={company_id}
                                    superAdmins={superAdmins}
                                    emailTemplate={emailTemplate}
                                    onClose={onClose}
                                />
                            )}
                            title="Upload Location Master"
                            id="upload_location_master_btn"
                            screenName="Company Profile"
                            moduleName="Location Master"
                            activityName="Location Master - Upload excel button clicked"
                            showLogo={true}
                            backdrop={true}
                        />

                        <button
                            id="delete_location_master_btn"
                            disabled={deletion_list.length === 0 || canedit || !canUpdate}
                            className="btn btn-danger"
                            onClick={(e) => deleteLanes(e)}
                        >
                            <i className="fa fa-trash pr-2" />
                            Delete
                        </button>

                        <DownloadMastersButton
                            type={"location"}
                            company_id={company_id}
                            masterList={locationMasterList}
                            totalCount={totalcount}
                        />

                        {/* Advanced Filter Button */}
                        <button
                            id="location-filter-btn"
                            className={`btn ${isFilterActive ? 'btn-success' : 'btn-primary'} px-3 py-2 text-nowrap`}
                            onClick={() => setfiltershown(!filtersshown)}
                            title={isFilterActive ? 'Filters are active' : 'Advanced Filters'}
                        >
                            <i className={`fa ${isFilterActive ? 'fa-check-circle' : 'fa-filter'} mr-2`} />
                            {isFilterActive ? 'Filters Applied' : 'Filter'}
                        </button>
                    </div>

                    {/* Right Side: Utility Buttons */}
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>

                        <PopupModal
                            id="location-activity-modal"
                            showLogo={true}
                            title="Activity Log for Masters"
                            buttonLabel={
                                <>
                                    <i className="far fa-clock pr-2" style={{ fontSize: "15px" }}></i>
                                    <span>Show Activity</span>
                                </>
                            }
                            buttonClass={`btn btn-info`}
                            disabled={canedit || !canUpdate}
                            content={<ShowHistory screen_name='location_master' />}
                            screenName="Location Master"
                            moduleName="Masters"
                            activityName="Location Master - Show Activity button clicked"
                            backdrop={true}
                        />

                        {isOrgLevel === true && (
                            <select
                                className="form-control"
                                style={{ maxWidth: "max-content" }}
                                value={selectedOrg}
                                onChange={(e) => setSelectedOrg(e.target.value)}
                            >
                                <option value={"company"}>Company</option>
                                {orgList && orgList.length > 0 &&
                                    orgList.map(item => (
                                        <option value={item.id} key={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        )}
                    </div>
                </div>

            {/* Active filter pills — attaches flush to the top of the table when filters are applied */}
            <ActiveFilterPills />

            <div className={classes["table-alignment"]}>
                <LocationMasterTable
                    locationMasterList={locationMasterList}
                    setLocationMasterList={setLocationMasterList}
                    deletion_list={deletion_list}
                    show={show}
                    checkboxeshandler={checkboxeshandler}
                    selectAllHandler={selectAllHandler}
                    ViewTruckDetails={ViewTruckDetails}
                    userDetails={userDetails}
                    truckOptions={truckOptions}
                    deleteHandler={deleteHandler}
                    company_id={company_id}
                    getTime={getTime}
                    emailTemplate={emailTemplate}
                    superAdmins={superAdmins}
                    selectedOrg={selectedOrg}
                    canedit={canedit}
                    canAccess={canAccess}
                    canUpdate={canUpdate}
                    checkActionPermission={checkActionPermission}
                />
            </div>
                <div className="text-center mt-3">
                    <Pagination
                        activePage={skipactive === 0 ? 1 : skipactive}
                        itemsCountPerPage={filterPayload?.pagination?.limit || 500}
                        totalItemsCount={totalcount}
                        onChange={(e) => getOnChange(e)}
                        itemClass="page-item"
                        linkClass="page-link"
                    />
                </div>
            </div>
        </>
    )
}

export default LocationMaster;